import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiHome, FiMapPin, FiFileText, FiArrowLeft, FiSave, FiAlertCircle, FiCheckCircle } from 'react-icons/fi';
import { createGuild } from './guildService';
import '../doctors/CreateDoctor.css'; // Reusing form styles

export default function CreateGuild() {
    const [formData, setFormData] = useState({
        name: '',
        area: '',
        description: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    function handleChange(e) {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
        setError(''); // Clear error on input change
    }

    async function handleSubmit(e) {
        e.preventDefault();

        if (!formData.name) {
            setError('Guild name is required');
            return;
        }

        try {
            setLoading(true);
            setError('');
            setSuccess(false);
            await createGuild(formData);
            setSuccess(true);

            // Show success message then navigate
            setTimeout(() => {
                navigate('/dashboard/guilds');
            }, 1500);
        } catch (err) {
            setError(err.message || 'Failed to create guild');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="page-container">
            <div className="page-header">
                <h1>Create Guild</h1>
                <button
                    type="button"
                    onClick={() => navigate('/dashboard/guilds')}
                    className="btn-secondary"
                >
                    <FiArrowLeft />
                    <span>Back to List</span>
                </button>
            </div>

            <div className="form-container">
                <form onSubmit={handleSubmit}>
                    {error && (
                        <div className="alert alert-error">
                            <FiAlertCircle />
                            <span>{error}</span>
                        </div>
                    )}

                    {success && (
                        <div className="alert alert-success">
                            <FiCheckCircle />
                            <span>Guild created successfully! Redirecting...</span>
                        </div>
                    )}

                    <div className="form-group">
                        <label htmlFor="name">
                            <FiHome />
                            <span>Guild Name *</span>
                        </label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="e.g. Chennai Medical Guild"
                            required
                            disabled={loading}
                        />
                        <small className="form-hint">
                            A descriptive name for the medical guild
                        </small>
                    </div>

                    <div className="form-group">
                        <label htmlFor="area">
                            <FiMapPin />
                            <span>Area / City</span>
                        </label>
                        <input
                            type="text"
                            id="area"
                            name="area"
                            value={formData.area}
                            onChange={handleChange}
                            placeholder="e.g. Chennai, Tamil Nadu"
                            disabled={loading}
                        />
                        <small className="form-hint">
                            Geographic location or coverage area
                        </small>
                    </div>

                    <div className="form-group">
                        <label htmlFor="description">
                            <FiFileText />
                            <span>Description</span>
                        </label>
                        <textarea
                            id="description"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            placeholder="Brief description of the guild's purpose and focus areas..."
                            rows="4"
                            disabled={loading}
                        />
                        <small className="form-hint">
                            Optional description of the guild's mission and specialties
                        </small>
                    </div>

                    <div className="form-actions">
                        <button
                            type="button"
                            onClick={() => navigate('/dashboard/guilds')}
                            className="btn-cancel"
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn-submit"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner"></span>
                                    <span>Creating...</span>
                                </>
                            ) : (
                                <>
                                    <FiSave />
                                    <span>Create Guild</span>
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
